import React, { FunctionComponent } from 'react'

import { useTheme } from 'styled-components/native'

import { Size } from '../../atoms/bodyText/BodyText'
import { AttentionIcon } from '../../atoms/icons/AttentionIcon'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { InlineBanner, InlineBannerProps } from '../inlineBanner/InlineBanner'

export interface InlineWarningBannerProps extends Omit<InlineBannerProps, 'backgroundColor' | 'textColor'> {
  iconColor?: string
  backgroundColor?: string
  textColor?: string
  withoutIcon?: boolean
  padding?: string
}

export const InlineWarningBanner: FunctionComponent<InlineWarningBannerProps> = ({
  text,
  testId,
  backgroundColor,
  iconColor,
  textColor,
  trailingLink,
  marginTop,
  marginBottom,
  textSize = Size.DEFAULT,
  title,
  withoutIcon,
  padding,
}) => {
  const { colors } = useTheme() as ThemeType
  const { inlineWarningBanner } = colors.components

  const icon = withoutIcon ? undefined : (
    <AttentionIcon size={15} fillColor={iconColor || inlineWarningBanner.warningIcon.fill} />
  )
  return (
    <InlineBanner
      text={text}
      icon={icon}
      testId={testId}
      backgroundColor={backgroundColor || inlineWarningBanner.background}
      textColor={textColor || inlineWarningBanner.text}
      trailingLink={trailingLink}
      marginBottom={marginBottom}
      marginTop={marginTop}
      textSize={textSize}
      title={title}
      padding={padding}
    />
  )
}
